class MemberRequestApiService {
  constructor(HttpService, SessionService) {
    'ngInject';

    this.HttpService = HttpService;
    this.SessionService = SessionService;
  }

getMemberRequests(payload = {}) {
  let queryParams = '';
  if (Object.keys(payload).length > 0) {
    queryParams = this.HttpService.buildQueryParamsFromPayload(payload);
  }

  return this.HttpService.get('/' + this.SessionService.getLocale() + `/member/request?${queryParams}`);
  }
}

export default MemberRequestApiService;


// WEBPACK FOOTER //
// ./client/app/api/services/memberrequest.api.service.js